<template>
  <div class="top_setting_btn" @mouseenter.stop="mouseenterEv" @mouseleave.stop="mouseleaveEv">
    <div class="wrapper" v-show="showTopSetting && ids.uid === uid">
      <cx-tooltip v-show="colPath.length > 1" content="选择父级" class="set-groups">
        <span class="icon icon-portal-aiming" @click.stop="findParentNode"></span>
      </cx-tooltip>
      <cx-tooltip content="克隆样式" class="set-groups">
        <span class="icon icon-portal-clone" @click.stop="toClonePattern"></span>
      </cx-tooltip>
      <cx-tooltip content="添加列" class="set-groups">
        <span class="icon icon-portal-round-add" @click.stop="update('add')"></span>
      </cx-tooltip>
      <cx-tooltip class="set-groups" :style="{ borderRight: isLast ? 'none' : '' }" content="复制">
        <span class="icon icon-portal-copy" @click.stop="update('paste')"></span>
      </cx-tooltip>
      <cx-tooltip v-show="!isFirst && !isOnlyCol" class="set-groups" content="左移">
        <span class="icon icon-portal-direction-left-2" @click.stop="exchange($event, 'prev')"></span>
      </cx-tooltip>
      <cx-tooltip v-show="!isLast && !isOnlyCol" class="set-groups" content="右移">
        <span class="icon icon-portal-direction-right-2" @click.stop="exchange"></span>
      </cx-tooltip>
      <cx-tooltip v-show="colPath.length > 1 || canDelete" class="set-groups" content="删除">
        <span class="icon icon-portal-delete1" @click.stop="update('del')"></span>
      </cx-tooltip>
    </div>
    <div class="btn-switch" @click="showSetting" v-show="showIcon" :style="topSettingStyle">
      <!--    <div @click="showSetting" :style="topSettingStyle">-->
      <span class="icon arrow-icon icon-portal-arrows-up"></span>
    </div>
  </div>
</template>

<script>
import { findColPathByUid } from "utils"
import store from "../../../store"
export default {
  props: {
    uid: {
      type: String,
      required: true
    },
    isActiveCol: {
      type: Boolean,
      required: true
    },
    ids: Object,
    myid: {
      type: Object,
      required: true
    },
    options: {
      type: Object,
      required: true
    },
    colsOptions: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isMounted: false,
      showTopSetting: false,
      isLast: false,
      isFirst: false,
      isTopCol: false,
      isOnlyCol: false,
      colPath: [],
      canDelete: false
    }
  },
  mounted() {
    this.isMounted = true
  },
  computed: {
    rectEl() {
      return document.getElementsByClassName(
        this.$event.getIdsByStrId({
          container_id: this.myid.container_id,
          rect_id: this.myid.rect_id
        })
      )[0]
    },
    showIcon() {
      if (this.isMounted === false) return false
      const isShow = this.isActiveCol || this.showTopSetting || this.ids.uid === this.uid
      // if (isShow) {
      //   this.rectEl.style.zIndex = 9999999
      // } else if (this.ids.container_id !== this.myid.container_id || this.ids.rect_id !== this.myid.rect_id) {
      //   this.rectEl.style.zIndex = this.options.hasOwnProperty("zIndex") ? this.options.zIndex : "auto"
      // }
      return isShow
    },
    topSettingStyle() {
      return {
        "--toolTopBackgroundColor": this.request_prefix.includes("bigScreen") ? "white" : "black",
        "--toolTopFontColor": this.request_prefix.includes("bigScreen") ? "black" : "white",
        "--settingShow": this.showTopSetting ? "scale(1.3)" : "scale(1)"
      }
    }
  },
  methods: {
    getColPath() {
      this.colPath = findColPathByUid(this.options.rows, this.uid) || []
      if(this.options.disableSetColAndRow){
      //  编组后的删除按钮需要非第一列显示
        if(this.colPath[0].cols?.length > 1 && !this.isFirst){
          this.canDelete = true
        }
      }
    },
    findParentNode() {
      localStorage.setItem("preventMouseenterEv", true)
      setTimeout(() => {
        localStorage.removeItem("preventMouseenterEv")
      }, 3000)
      //路径的倒数第二个就是上一个col
      const tarColInPath = this.colPath[this.colPath.length - 2]
      const parentCol = tarColInPath.cols[tarColInPath.colId]
      const param = {
        ...this.myid,
        uid: parentCol.uid,
        option_name: "isActive",
        option_val: "delAllActive"
      }
      //清理被选中单元格中的所有组件的选中状态
      this.$store.dispatch(this.request_prefix + "/changeLayoutActive", param)
      if (parentCol.elementOptions.length) {
        const delAllTitleActive = {
          container_id: this.myid.container_id,
          rect_id: this.myid.rect_id
        }
        this.$store.dispatch(this.request_prefix + "/delAllLayoutTitleActive", delAllTitleActive)
      }
      const activeID = {
        container_id: this.myid.container_id,
        rect_id: this.myid.rect_id,
        uid: parentCol.uid
      }
      this.$store.commit("states/changeElementType", "colsComponent")
      this.$store.commit("states/changeActiveID", activeID)
      this.$changeOptionsEV(parentCol.uid, "activeCol", false, null, {
        container_id: this.myid.container_id,
        rect_id: this.myid.rect_id
      })
    },
    //进入克隆模式
    toClonePattern() {
      this.showTopSetting = false
      this.$store.commit("states/changeGeneralAttr", {
        valName: "isClonePattern",
        val: true
      })
      this.$emit("toClonePattern")
    },
    calcIsLast(deep = 0) {
      if (this.isMounted === false) {
        this.isLast = false
        this.isFirst = false
      }
      const currCol = this.$el?.parentNode
      const corrCols = currCol?.parentNode.childNodes
      if (!corrCols && deep < 10) requestAnimationFrame(() => this.calcIsLast(deep + 1))
      else {
        const index = Array.prototype.findIndex.call(corrCols, item => item === currCol)
        this.isLast = index === corrCols.length - 1
        this.isFirst = index === 0
      }
    },
    calcIsOnlyCol() {
      if (this.isMounted === false) this.isOnlyCol = false
      this.isOnlyCol = this.$el.parentNode.parentNode.childNodes.length === 1
    },
    hiddenSetting() {
      this.showTopSetting = false
    },
    showSetting() {
      this.showTopSetting = !this.showTopSetting
      if (this.showTopSetting) {
        this.$emit("activeCol")
        this.calcDeps()
      } else {
        this.setPageLayoutWrapZindex(false)
      }
    },
    calcDeps() {
      this.calcIsLast()
      this.getColPath()
      this.calcIsOnlyCol()
      this.setPageLayoutWrapZindex(true)
    },
    // 设置外层页面布局的层级 当前的为最高
    setPageLayoutWrapZindex(show) {
      let parentNode = this.getParentNode(this.$el)
      if (parentNode.length === 0) {
        return
      }
      if (show) {
        parentNode[0].setAttribute("data-level", "top-level")
      } else {
        parentNode[0].removeAttribute("data-level")
      }
    },
    getParentNode(e, res = []) {
      if (e && e.parentNode) {
        const parentNode = e.parentNode
        let elClasslist = parentNode.classList
        // if(elClasslist.length === 0){
        //   return  res
        // }
        if ([].find.call(elClasslist, it => it === "myContainer")) {
          return []
        } else if ([].find.call(elClasslist, it => it === "page-layout-wrapper")) {
          res.push(parentNode)
        }
        if (res.length > 0) {
          return res
        } else {
          return this.getParentNode(parentNode, res)
        }
      } else {
        return res
      }
    },
    exchange(e, type) {
      this.$store.dispatch(this.request_prefix + `/exchangeLayoutCol`, {
        ...this.myid,
        uid: this.uid,
        shareWidth: true,
        type
      })
    },
    update(type) {
      //pasteCol delCol exchangeCol
      this.$store.dispatch(this.request_prefix + `/${type}LayoutCol`, {
        ...this.myid,
        uid: this.uid,
        shareWidth: true
      })

      if (type === "exchange") {
        requestAnimationFrame(() => {
          this.$emit("reloadBtn")
        })
      }
    },
    mouseenterEv() {
      this.$emit("mouseenter")
    },
    mouseleaveEv() {
      this.$emit("mouseleave")
    },
  }
}
</script>

<style scoped>
.top_setting_btn {
  z-index: 9999999;
  position: absolute;
  top: -9px;
  right: -9px;
}
.wrapper {
  color: var(--toolTopFontColor);
  background-color: #283959;
  white-space: nowrap;
  margin-bottom: 10px;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  border-radius: 999px;
  padding: 0 8px;
  transition: top 0.4s;
  height: 34px;
  top: 24px;
  /*transition: 0.4s;*/
}
.wrapper::after {
  /* display: block; */
  position: absolute;
  content: "";
  width: 100%;
  height: 20px;
  bottom: -20px;
  left: 0px;
}
.content span {
  padding: 1px;
  border-radius: 2px;
  line-height: 17px;
}
.set-groups:not(:last-child) {
  display: inline-block;
  vertical-align: middle;
  border-right: 1px solid #42516d;
}
.icon {
  font-size: 18px;
  text-align: center;
  line-height: 34px;
  color: rgba(255, 255, 255, 0.8);
  cursor: pointer;
}
.set-groups {
  display: inline-block;
  vertical-align: middle;
  width: 34px;
  height: 34px;
}
.set-groups .icon:hover {
  color: rgba(255, 255, 255, 1);
}
.arrow-icon {
  display: inline-block;
  width: 18px;
  height: 18px;
  line-height: 18px;
  font-size: 16px;
  padding-right: 1px;
  text-align: center;
  background-color: var(--themeColor);
  color: #fff;
  border-radius: 50%;
  transition: all 0.1s;
  cursor: pointer;
  transform: var(--settingShow);
}
.icon-portal-move {
  padding-right: 0px;
}
.arrow-icon:hover {
  cursor: pointer;
}
::v-deep .content {
  line-height: 38px;
}
</style>
